import React, { useState, useEffect } from "react";

// Style //
import "./Site.css";

// Table //
import Table from "react-bootstrap/Table";

// Components //
import {
  PageHeading,
  SearchBar,
  DropDown,
  ButtonComp,
  TableRowLoader,
} from "../../common/components/index";
import Pagination from "rc-pagination";

// Hooks //
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

// API's //
import { archiveSiteApi, getSiteProjectApi } from "../../api/siteProjectApi";

// Actions //
import {
  receivedError,
  requestSent,
  responseRecived,
} from "../../redux/actions/utilsActions";

const Site = () => {
  // Hooks //
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isArchived = location.pathname.endsWith('archived');
  const { loading } = useSelector((state) => state.utils);
  const { userToken } = useSelector((state) => state.user)
  const [sitesData, setSitesData] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams({ page: 1, show: 10 })
  const [currentPage, setCurrentPage] = useState();
  const [totalCount, setTotalCount] = useState(8);
  const [limitPerPage, setlimitPerPage] = useState(10);
  const [siteName, setSiteName] = useState("");

  useEffect(() => {
    getSiteProjectData({
      page: searchParams.get("page") || 1,
      limit: searchParams.get("show") || 10,
      name: siteName,
    });
    setCurrentPage(Number(searchParams.get("page")) || 1)
    setlimitPerPage(Number(searchParams.get("show")) || 10)
  }, [location.pathname]);

  // API Calls //
  const getSiteProjectData = async (value) => {
    try {
      dispatch(requestSent());

      const data = await getSiteProjectApi(userToken, {
        page: value.page,
        limit: value.limit,
        name: value.name,
        is_archived: isArchived
      });

      setSitesData(data.data.rows);
      setTotalCount(data?.data.count);
      dispatch(responseRecived());
    } catch (error) {
      dispatch(receivedError(error));
    }
  };

  // Haandlers //
  const handleShow = (value) => {
    setlimitPerPage(value);
    setSearchParams({ page: 1, show: value })
    getSiteProjectData({
      page: 1,
      limit: value,
      name: '',
    });
  };

  const handleSearch = (value) => {
    setSiteName(value);
    getSiteProjectData({
      page: 1,
      limit: 10,
      name: value,
    });
  };

  const updatePageHandler = (p) => {
    setSearchParams({ page: p, show: searchParams.get("show") })
    setCurrentPage(p);
    getSiteProjectData({
      page: p,
      limit: limitPerPage,
      name: '',
    });
  };

  const archieveSite = async (id) => {
    try {
      dispatch(requestSent());

      await archiveSiteApi(userToken, { site_id: id, archive: !isArchived });
      getSiteProjectData({
        page: searchParams.get("page"),
        limit: searchParams.get("show"),
        name: siteName,
      });
      dispatch(responseRecived());
    } catch (error) {
      console.log("Sole Trader Details Error::::", error);
      dispatch(receivedError(error));
    }
  };

  const toggleArchivedReinstatedSites = () => {
    setSearchParams({ page: 1, show: 10 })
    setSiteName('');
    if (isArchived) {
      navigate("/sites/")
    } else {
      navigate("/sites/archived")
    }
  }

  return (
    <div id="site_projects">
      <>
        <PageHeading title={"Sites / Projects"} />
        <div className="filter_cont justify-content-between">
          <div className="d-flex col-6">
            <DropDown
              label={"Show"}
              listItems={["2", "8", "10", "15", "20", "25"]}
              onSelect={handleShow}
              value={limitPerPage}
            />
            <SearchBar onChange={handleSearch} value={siteName} button={true} placeholder={"Search Sites"} />
          </div>

          <ButtonComp
            onClick={() => navigate("/sites/add-sites")}
            title={"Add Site/project"}
            width={"25%"}
          />
        </div>
        <div className="right-sec_cont" style={{ width: 'fit-content' }}>
          {loading ? (
            <TableRowLoader limit={limitPerPage} />
          ) : (
            <>
              <Table className="common-table" bordered>
                <thead>
                  <tr>
                    <th>SITE REF ID.</th>
                    <th>Client</th>
                    <th>Site / Project Name</th>
                    <th>Address</th>
                    <th>Post Code</th>
                    <th>Active Sub-Contractors</th>
                    <th>{isArchived ? 'Reinstate' : 'Archive'}</th>
                    <th>Site Specific Training Matrix</th>
                  </tr>
                </thead>
                <tbody>
                  {sitesData.length ? sitesData.map((item, index) => (
                    <tr key={index}>
                      <td>{item.reference}</td>
                      <td>{item.client_name}</td>
                      <td className="text-uppercase">
                        {item?.name}
                      </td>
                      <td>{item?.address}</td>
                      <td>{item?.post_code}</td>
                      <td>
                        {item?.TimeSheets.length}
                      </td>
                      <td>
                        <button
                          style={{
                            borderColor: "orange",
                            borderWidth: "1",
                            fontWeight: "lighter",
                          }}
                          onClick={() => {
                            archieveSite(item.id);
                          }}
                        >
                          {isArchived ? 'REINSTATE' : 'ARCHIVE'}
                        </button>
                      </td>
                      <td>
                        <button onClick={() => navigate(`/sites/site-details?site_id=${item.id}`, {
                          state: {
                            siteInfo: {
                              id: item.id,
                              siteName: item?.name,
                              reference: item.reference,
                              client_name: item.client_name
                            }
                          }
                        })}>
                          View Full Details
                        </button>
                      </td>
                    </tr>
                  )) : <tr>
                    <td colSpan={8} style={{ fontSize: '1rem' }}>No Sites Found</td>
                  </tr>}
                </tbody>
              </Table>
              <div className="pagination_cont">
                <ButtonComp
                  onClick={toggleArchivedReinstatedSites}
                  title={isArchived ? 'Reinstated Site/project' : "Archived Site/project"}
                  width={"20%"}
                  style={{ marginRight: 'auto' }}
                />
                <Pagination
                  pageSize={limitPerPage}
                  onChange={updatePageHandler}
                  current={currentPage}
                  total={totalCount}
                />
              </div>
            </>
          )}
        </div>
      </>
    </div>
  );
};

export default Site;
